import React, { useEffect, useRef, useState, useReducer, useMemo, useCallback } from 'react'
import axios from 'axios'
import { useDropzone } from 'react-dropzone'
import Loading from "./Loading";
import { patch, get } from "@rails/request.js";
import { Modal, useModal } from "./Modal";

export const ExplainerScreen = ({open, title}) => {
  const { modalOpen, setModalOpen } = useModal(open)
  let url = ''
  if (title === 'What are Capture Forms?') {
    url = 'https://images.shosay.com/CapformDemo.mp4'
  }
  return <>
    <div className='text-ssblue cursor-pointer underline-dotted' onClick={() => setModalOpen(true)}>{title}</div>
    { modalOpen && <Modal modalOpen={modalOpen} setModalOpen={setModalOpen} icon='image' >
      <div className="relative p-8">
        <div className="sm:text-center">
          <h2 className="text-3xl font-extrabold text-slate-900 tracking-tight sm:text-4xl">{title}</h2>
        </div>
        <div className='h-[400px] w-[400px] sm:h-[700px] sm:w-[700px] mx-auto p-5 aspect-w-1 aspect-h-1'>
        <video controls className="h-full w-full mx-auto object-cover rounded-md cursor-pointer shadow-lg border border-gray-400 border-dashed border-2" src={url} />
        </div>
      </div>
    </Modal> }
  </>
}
